export default {
    visitor: 'Visitor',
    searchBy: 'Search by Visitor Name',
    search: 'Search',
    createNewVisitor: 'Create New Visitor',
    visitorName: 'Visitor Name',
    contact: 'Contact',
    contactNo: 'Contact No.',
    joinedDate: 'Joined Date',
    access: 'Access',
    status: 'Status',
    active: 'Active',
    deactive: 'Deactive',
    allStatus: 'All Status',
    deleteVisitor: 'Delete Visitor',
    congratulation: 'Congratulation',
    msgDeleteSuccess: 'Visitor is deleted.',
    questionDelete: 'Are you sure to delete "$Name"?'
}
